"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatesService = void 0;
const tslib_1 = require("tslib");
const lists_1 = require("src/lists");
const location_1 = require("src/location");
const BaseLocationService_1 = require("./BaseLocationService");
class StatesService extends BaseLocationService_1.BaseLocationService {
    get serviceName() {
        return 'StatesService';
    }
    constructor(config) {
        super(config);
        this.statesServiceStorageKey = 'statesInfo';
        this.getDataForSelectOptions = (countryCode) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const [states, translations] = yield this.getData(countryCode);
            const result = this.mapItemsToUIModel(states, translations, BaseLocationService_1.LocationItemToEnum.SelectOptionItem, location_1.StateApi.STATE_PREFIX);
            if (result) {
                result.sort((0, lists_1.getStringCompareFunction)('title'));
            }
            return result;
        });
        this.getTranslatedStatesObjectByCountryCode = (countryCode) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const [states, translations] = yield this.getData(countryCode);
            const result = this.mapItemsToUIModel(states, translations, BaseLocationService_1.LocationItemToEnum.SelectOptionItem, location_1.StateApi.STATE_PREFIX);
            return result.reduce((statesObject, state) => {
                statesObject[state.value] = state.title;
                return statesObject;
            }, {});
        });
        this.getDataForFilterAutoComplete = (countryCode) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const [states, translations] = yield this.getData(countryCode);
            const result = this.mapItemsToUIModel(states, translations, BaseLocationService_1.LocationItemToEnum.FilterAutoCompleteItem, location_1.StateApi.STATE_PREFIX);
            if (result) {
                result.sort((0, lists_1.getStringCompareFunction)('value'));
            }
            return result;
        });
        this.getData = (culture) => {
            const apiCountryCode = this.parseCountryCode(culture);
            const apiLanguageCode = this.languageCode;
            const statesPromise = this.stateApi
                .loadStatesInfo(apiCountryCode)
                .then(this.mapStatesApiDataToLocationInfoModel);
            const translationPromise = this.stateTranslateApi
                .loadTranslatedStates(apiCountryCode, apiLanguageCode)
                .then(this.mapToLocationTranslation)
                .then(this.filterOutInvalidTranslation);
            return Promise.all([statesPromise, translationPromise]);
        };
        this.mapToLocationTranslation = (data) => {
            const translations = data.value;
            return translations.map(item => {
                return { code: item.id, translation: item.name };
            });
        };
        this.mapStatesApiDataToLocationInfoModel = (data) => {
            const states = data.value;
            return states.map((state) => {
                return {
                    code: state.id,
                    name: state.name,
                };
            });
        };
        this.stateApi = new location_1.StateApi({
            storage: sessionStorage,
            storageKey: this.createDefaultStorageKey(this.statesServiceStorageKey),
            url: config.apiUrl,
            locationApiKey: config.locationApiKey,
        });
        this.stateTranslateApi = new location_1.StateApi({
            storage: sessionStorage,
            storageKey: this.createLocaleStorageKey(this.statesServiceStorageKey),
            url: config.apiUrl,
            locationApiKey: config.locationApiKey,
        });
    }
}
exports.StatesService = StatesService;
